import { render, staticRenderFns } from "./ReportSearchWordsChart.vue?vue&type=template&id=d981fbd0"
import script from "./ReportSearchWordsChart.vue?vue&type=script&lang=js"
export * from "./ReportSearchWordsChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports